import { maskImageId } from "domains/canvas/components/sections/AIPanel/maskImageId";

export const toolVisibleElements = [
  //   resizeGuideId,
  maskImageId,
  // Context zone should not be manipulable by user
  //   contextZoneId,
];
